export default "__VITE_PUBLIC_ASSET__ca49342d__"